import { createFileRoute } from "@tanstack/react-router";
import { PageHead, Panel } from "@/components/dashboard-shell";
import { institutions } from "@/data/sample";

export const Route = createFileRoute("/institution/profile")({ component: Profile });

function Profile() {
  const i = institutions[0];
  return (
    <>
      <PageHead title="Profile" subtitle="Public profile, contact, mission and documents." />
      <div className="grid gap-4 lg:grid-cols-2">
        <Panel title="Basic details">
          <F label="Institution name" defaultValue={i.name} />
          <F label="Type" defaultValue={i.type} />
          <F label="Established" defaultValue={String(i.established)} />
          <F label="Animals cared for" defaultValue={String(i.animalCount)} />
        </Panel>
        <Panel title="Contact">
          <F label="Contact person" defaultValue={i.contactPerson} />
          <F label="Phone" defaultValue={i.phone} />
          <F label="Email" defaultValue={i.email} />
          <F label="Address" defaultValue={`${i.address}, ${i.city}`} />
        </Panel>
        <Panel title="Mission">
          <textarea
            defaultValue={i.mission}
            rows={4}
            className="w-full rounded-xl border border-border bg-background px-4 py-2 text-sm"
          />
        </Panel>
        <Panel title="Bank verification">
          <p className="text-sm text-foreground/65">
            Bank account verified by admin. Any change requires re-verification.
          </p>
          <button className="mt-3 rounded-full border border-border px-4 py-2 text-xs">
            Request change
          </button>
        </Panel>
      </div>
    </>
  );
}
function F({ label, defaultValue }: { label: string; defaultValue: string }) {
  return (
    <label className="block py-2">
      <span className="text-xs text-foreground/60">{label}</span>
      <input
        defaultValue={defaultValue}
        className="mt-1 w-full rounded-xl border border-border bg-background px-4 py-2 text-sm"
      />
    </label>
  );
}
